import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { connectSocket, disconnectSocket } from '@/lib/socket';

/**
 * Component không render UI.
 * Đặt trong App tree để auto-connect/disconnect socket theo auth state.
 */
export default function SocketProvider({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user } = useAuthStore();

  useEffect(() => {
    if (isAuthenticated && user?.id) {
      connectSocket(user.id);
    } else {
      disconnectSocket();
    }
    return () => {
      disconnectSocket();
    };
  }, [isAuthenticated, user?.id]);

  return <>{children}</>;
}
